import { UsdPriceService } from '@cronos-app/binding-swap-sdk';
import { ChainLayer, getChainOfLayer } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { FeatureFlag, isFeatureEnabled } from '@ui/configs/featureFlags';
import { Token } from '@ui/models';
import { Fraction } from 'bi-fraction';
import { useEffect } from 'react';

import { danger_tokenAdapter } from '../configs/token';
import type { ExtendedTokenInfo } from '../types';
import { useCardLayer } from '../useCardContextStore';
import { getCdcDepositCardService } from './useCdcDepositCardService';

declare global {
  interface Window {
    getSwapCalldatasRaw: (
      from: ExtendedTokenInfo,
      to: ExtendedTokenInfo,
      amount: string,
      sc?: string,
    ) => Promise<void>;
    getUsdPrice: (token: ExtendedTokenInfo) => Promise<void>;
  }
}
export const useSwapAndTopUpArgs_test = () => {
  const layer = useCardLayer();
  const account = currentWallet.useAccount();
  const provider = currentWallet.useProvider();
  const network = currentWallet.useDesiredNetwork();
  useEffect(() => {
    if (
      !isFeatureEnabled(FeatureFlag.TopUpTestService) ||
      !account ||
      !provider
    )
      return;
    const getSwapCalldatasRaw = async (
      from: ExtendedTokenInfo | undefined,
      to: ExtendedTokenInfo,
      amount: string,
      sc?: string,
    ) => {
      if (!from) {
        from = danger_tokenAdapter(
          network,
          layer === ChainLayer.CronosEvm
            ? Token.CRO
            : layer === ChainLayer.L2
            ? Token.zkCRO
            : Token.ETH,
          layer,
          true,
        );
      }
      const service = getCdcDepositCardService(network, layer);
      if (!sc) {
        sc = service.swapAndTopUpScAddr;
      }
      const data = await service.getter_swapAndTopUpArgs(
        sc,
        {
          ...from,
          amount: new Fraction(amount).shl(from.decimals).toFixed(0),
        },
        to,
      );
      console.log('getSwapCalldatas:', data);

      try {
        const gas = await service.estimateGas_swapAndTopUp(
          account,
          data.swapInfo,
          await provider.getSigner(),
          true,
        );
        console.log('gas:', gas);
      } catch (err) {
        //
      }

      console.log('exec:', async () =>
        service.exec_swapAndTopUp(
          data.swapInfo,
          await provider.getSigner(),
          true,
        ),
      );
    };
    const getUsdPrice = async (token: ExtendedTokenInfo) => {
      const ans = await new UsdPriceService(
        +getChainOfLayer(network, layer),
      ).calcUSDPrice(token);
      console.log('getUsdPrice:', token, ans?.toFixed(18));
    };

    window.getSwapCalldatasRaw = getSwapCalldatasRaw;
    window.getUsdPrice = getUsdPrice;
  }, [account, layer, network, provider]);
};
